import { execAdmin } from '@src/apis/reware/utils';

import type { PricingRule } from './types';

export interface FetchPricingRuleArgs {
  partnerId: number;
  ruleId: number;
}

interface FetchPricingRuleExecVariables {
  partnerId: number;
  ruleId: number;
}

interface FetchPricingRuleExecResponse {
  partner: {
    pricingRule: PricingRule | null;
  };
}

export const fetchPricingRule = async ({
  partnerId,
  ruleId,
}: FetchPricingRuleArgs): Promise<PricingRule | null> => {
  const query = `
    query getPricingRule($partnerId: Int!, $ruleId: Int!) {
      partner(id: $partnerId) {
        pricingRule(ruleId: $ruleId) {
          id
          position
          condition
          department
          category
          merchantCategory
          tag
          name
          secondaryTag
          secondaryName
          tertiaryTag
          tertiaryName
          discount
          sourceColumn
          upc
        }
      }
    }
  `;

  const data = await execAdmin<FetchPricingRuleExecVariables, FetchPricingRuleExecResponse>(query, {
    variables: { partnerId, ruleId },
  });

  return data.partner.pricingRule;
};
